module.exports = __webpack_public_path__ + "img/chat_icon_selected_mobile.d4bd7eb2.svg";